import ButtonLink from "src/components/buttonlink/ButtonLink";
import StreamingPosterRowWithSelfLoad, { prefetch } from "src/components/forsiden/StreamingPosterRowWithSelfLoad";
import ExternalImageForUrl from "src/components/images/ExternalImageForUrl";
import PosterRow from 'src/components/posterrow/PosterRow';
import { IFilmomtale } from 'src/lib/types/Filmomtale';
import { GroupedLayoutObject, IMovieListBlock, IPosterList, ItemType_ListPosterRow, ItemType_PosterList, PublishableDocument } from "src/lib/types/IForsidenV2";
import IMovieList from "src/lib/types/MovieList";
import classNames from 'classnames';
import styles from './PosterRowWithTitleV2.module.css';

//#region [Props]
type PosterRowWithTitleProps = {
    posterRow: GroupedLayoutObject<IPosterList | IMovieListBlock>;
};
//#endregion

export { prefetch };

//#region [Component]
export default function PosterRowWithTitleV2({ posterRow }: PosterRowWithTitleProps) {
    if (((posterRow.movies as PublishableDocument[])?.length ?? 0) === 0 && (posterRow.articles?.length ?? 0) === 0) {
        return null;
    }

    const movies = posterRow.movies ?? posterRow.articles;

    const isContentMarketing = !!posterRow.extLogoUrl;

    return <section className={classNames(styles.SPosterRowWithTitle)}>
        <h1 className={classNames(styles.SSectionTitle, { [styles.contentMarketing]: isContentMarketing })}>
            {posterRow.title} {isContentMarketing && <ContentMarketerLogo className={classNames(styles.SContentMarketerLogo)} logoUrl={(posterRow as IMovieListBlock).extLogoUrl!} logoLink={posterRow.extLogoLink as (string | undefined)} />}
        </h1>
        {posterRow._type === ItemType_PosterList && <PosterRow className={classNames(styles.SPosterRow)} max={6} posterList={movies as IFilmomtale[]} />}
        {posterRow._type === ItemType_ListPosterRow && <>
            <StreamingPosterRowWithSelfLoad max={6} movieList={posterRow.articles![0] as IMovieList} />
            {(posterRow.articles![0] as IMovieList).streamingIds.length > 6 && <ButtonLink className={classNames(styles.SButtonLink)} href={`/streamingguide/list/${(posterRow.articles![0] as IMovieList).slug.current}`}>Se alle</ButtonLink>}
        </>}
    </section>;
}
//#endregion

//#region [Component]
type ContentMarketerLogoProps = {
    logoUrl: string;
    logoLink?: string;
    className?: string;
};

function ContentMarketerLogo({ logoUrl, logoLink, className }: ContentMarketerLogoProps) {
    if (logoLink) {
        return <a href={logoLink} rel="noopener" className={className}><ExternalImageForUrl imageUrl={logoUrl} alt="Annonsor" /></a>
    }

    return <ExternalImageForUrl imageUrl={logoUrl} alt="Annonsor" className={className} />
}
//#endregion

//#region [Styles]
// Moved to CSS Modules (PosterRowWithTitleV2.module.css)
//#endregion

